import { IEntityWithStatus, EntityWithStatus } from "./EntityWithStatus";
import { App03Frameworks, IApp03Workflow } from "./App03Workflow";
import { IEntityCustomFields } from "./EntityCustomFields";
import { IEntityContributors } from "./EntityContributors";
import { IApp03Portfolio } from "./App03Portfolio";
import { IProjectStage } from "./ProjectStage";
import { IApp03ProjectType } from "./App03ProjectType";
import { IUser } from "./User";


export interface IApp03Project extends IEntityWithStatus, IEntityCustomFields, IEntityContributors {
    Objectives?: string
    PortfolioID?: number;
    ProjectTypeID?: number
    ProjectStageID?: number
    StartDate?: Date
    EndDate?: Date
    OwnerUserID?: number
    FrameworkID?: number;
    CustomerID?: number;
    App03ProjectTypeID?: number;
    OwnerUser?: IUser;
    Portfolio?: IApp03Portfolio;
    ProjectStage?: IProjectStage;
    ProjectType?: IApp03ProjectType;
    App03Workflows?: IApp03Workflow[];
}

export class App03Project extends EntityWithStatus implements IApp03Project {
    public Objectives = null;
    public PortfolioID = null;
    public ProjectTypeID = null;
    public ProjectStageID = null;
    public StartDate = null;
    public EndDate = null;
    public OwnerUserID = null;
    public FrameworkID = null;
    public CustomerID = null;
    public App03ProjectTypeID = null;
    public CustomFields = [];
    public Contributors = [];

    constructor(app03ProjectTypeID: number, frameworkID: App03Frameworks) {
        super();
        this.App03ProjectTypeID = app03ProjectTypeID;
        this.FrameworkID = frameworkID;
    }
}